import { Box, CircularProgress } from "@mui/material";
import { JSX } from "react";
import { Typography } from "@platform/design-system";

const RfpLoader = (): JSX.Element => (
  <Box
    sx={{
      top: "50%",
      position: "absolute",
      left: "50%",
      transform: "translate(-50%, -50%)",
      textAlign: "center",
    }}
  >
    <CircularProgress size="4rem" />
    <Typography mt={3} mb={1} variant="display-small">
      We are processing your request
    </Typography>
    <Typography variant="body-large">Just a moment, please...</Typography>
  </Box>
);

export default RfpLoader;
